import { useAsync, useMutation } from "./useAsync";
import * as api from "../lib/api";

/** Fetch sharing settings and leaderboard data for the admin panel. */
export function useAdminSharingDashboard() {
  return useAsync(() => api.getAdminSharingDashboard(), []);
}

/** Save sharing settings from the admin panel. */
export function useUpdateAdminShareSettings() {
  return useMutation(
    (settings: { warning_threshold: number; notification_email: string | null }) =>
      api.updateAdminShareSettings(settings),
  );
}
